import { render, staticRenderFns } from "./ejectQuestion.vue?vue&type=template&id=79125340&"
import script from "./ejectQuestion.vue?vue&type=script&lang=js&"
export * from "./ejectQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports